import {
  containsLower,
  containsUpper,
  testPassword,
} from '@/lib/utils/password';
import { CheckedIcon } from '../icons/checked';
import cn from 'classnames';

export function PasswordRules({ password = '' }: Readonly<{ password: string }>) {
  return (
    <div className="flex flex-col gap-y-2">
      <div className="flex items-center gap-x-2">
        <CheckedIcon
          className={cn(
            'w-4 h-4',
            password.length > 7 ? 'text-accent' : 'text-gray-400',
          )}
        />
        <span
          className={cn(
            'text-sm',
            password.length > 7 ? 'text-accent' : 'text-gray-200',
          )}
        >
          Mínimo 8 caracteres
        </span>
      </div>

      <div className="flex items-center gap-x-2">
        <CheckedIcon
          className={cn(
            'w-4 h-4',
            testPassword(password) ? 'text-accent' : 'text-gray-400',
          )}
        />
        <span
          className={cn(
            'text-sm',
            testPassword(password) ? 'text-accent' : 'text-gray-200',
          )}
        >
          Mínimo 1 número
        </span>
      </div>

      <div className="flex items-center gap-x-2">
        <CheckedIcon
          className={cn(
            'w-4 h-4',
            containsUpper(password) ? 'text-accent' : 'text-gray-400',
          )}
        />
        <span
          className={cn(
            'text-sm',
            containsUpper(password) ? 'text-accent' : 'text-gray-200',
          )}
        >
          Mínimo 1 letra maiúscula
        </span>
      </div>

      <div className="flex items-center gap-x-2">
        <CheckedIcon
          className={cn(
            'w-4 h-4',
            containsLower(password) ? 'text-accent' : 'text-gray-400',
          )}
        />
        <span
          className={cn(
            'text-sm',
            containsLower(password) ? 'text-accent' : 'text-gray-200',
          )}
        >
          Mínimo 1 letra minúscula
        </span>
      </div>
    </div>
  );
}
